<template>
  <div class="unavailable">
    <div>
      <font-awesome-icon icon="screwdriver-wrench"></font-awesome-icon>
    </div>

    <h1>We&rsquo;ll be back soon!</h1>
    <div>
      <p>
        Sorry for the inconvenience. We&rsquo;re performing some maintenance at the moment. If you
        need to you can always contact <a :href="supportEmail">Support</a> for updates, otherwise
        we&rsquo;ll be back up shortly!
      </p>
      <p>&mdash; The TimeOnline Team</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unavailable',
  data() {
    return {
      supportEmail: 'mailto:support@timeonline.com'
    };
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/colors.scss';
@import '../../styles/variables.scss';

.unavailable {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 50px;
  align-items: center;
  background-color: purple;
  color: $white;
  h1 {
    font-size: 50px;
    font-weight: 100;
    text-align: center;
  }
  a {
    color: #fff;
    font-weight: bold;
  }
  a:hover {
    text-decoration: none;
  }
  svg {
    width: 75px;
    height: 75px;
    margin-bottom: 15px;
    font-size: 50px;
  }
}
</style>
